/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import Button from '../Button'
import FormattedRadioButton from '../FormatttedRadioButton'
import HelpButton from '../HelpButton'

const PeopleAmountBlock = ({ 
  user,
  booking,
  updateBooking,
  onChange,
  getKey,
  atUserBookingsCapacity
}
) => {

  const [amountPeople, setAmountPeople] = useState(null)
  const [amountPeopleKids, setAmountPeopleKids] = useState(null)

  
  useEffect(() => {
    // Set initial "amountPeople" & amountPeopleKids values
    setAmountPeople(booking.amountPeople)
    setAmountPeopleKids(booking.amountPeopleKids)
  }, [booking.amountPeople, booking.amountPeopleKids])

  const updateAmount = (e, value) => {
    if(e.target.name === "amountPeople") {
      setAmountPeople(value)
    } else {
      setAmountPeopleKids(value)
    } 
    onChange(e.target.name, value)
  }

  const handleAmountChange = (e, adult, increase) => {

    if(adult) {
      if(increase) {
        return amountPeople < 10 ? updateAmount(e, amountPeople+1) : null
      }
      const minimum = booking.bookerNotAttending ? 0 : 1
      return amountPeople > minimum ? updateAmount(e, amountPeople-1) : null
    } else {
      if(increase) {
        return amountPeopleKids < 10 ? updateAmount(e, amountPeopleKids+1) : null
      }
      return amountPeopleKids > 0 ? updateAmount(e, amountPeopleKids-1) : null
    }
  }
  
  return (
  
    <div className="mt-8 sm:flex flex-row justify-between">
      <div className="flex-grow">
        
        <h5 className="uppercase text-grey tracking-wide-2xl">
          {user ? (
            <FormattedMessage id="booking.amountForm.loggedIn.subHeader" defaultMessage="New booking" />
          ) : (
            <FormattedMessage id="booking.amountForm.guest.subHeader" defaultMessage="Begin your booking here" />
          )}
        </h5>
        
        <h2 key={getKey()} className="mb-4 mt-5">
          {user ? (
            <FormattedMessage id="booking.amountForm.loggedIn.header" defaultMessage="New booking" />
          ) : (
            <FormattedMessage id="booking.amountForm.guest.header" defaultMessage="How many people are you booking for?" />
          )}
        </h2>

        <p className="sm:w-3/4">
          <FormattedMessage id="booking.amountForm.description" defaultMessage="Bookings must be done by an adult" />
        </p>
      </div>

      <div className="flex flex-col mt-2 justify-center text-center">
        <div className="text-sky text-xs font-bold mt-8">
          <FormattedMessage
            id="booking.amountForm.adults.label"
            defaultMessage="Adults"
          />
        </div>
        <div className="flex justify-center">
          <button
            name="amountPeople"
            className={`focus:outline-none text-grey-dark hover:border-grey-darkest font-semibold p-3 w-10 h-10 text-sm hover:text-grey-darkest border border-grey rounded-full mr-2
              ${!booking.bookerNotAttending && amountPeople === 1 && 'opacity-50 cursor-not-allowed hover:border-grey'}
            `}
            style={{ touchAction: 'manipulation' }}
            onClick={(e) => handleAmountChange(e, true, false)}
            type="button"
            disabled={!booking.bookerNotAttending && amountPeople === 1}
          >
            -
          </button>
          <div className="py-2 px-8 border border-grey no-underline 
            rounded-full bg-transparent text-black font-sans font-semibold text-sm mr-2"
          >
            {amountPeople}
          </div>
          <button
            name="amountPeople"
            className="focus:outline-none text-grey-dark hover:border-grey-darkest font-semibold p-3 w-10 h-10 text-sm hover:text-grey-darkest border border-grey rounded-full"
            style={{ touchAction: 'manipulation' }}
            onClick={(e) => handleAmountChange(e, true, true)}
            type="button"
          >
          +
          </button>
        </div>
        <div className="text-sky text-xs font-bold mt-6">
          <FormattedMessage
            id="booking.amountForm.kids.label"
            defaultMessage="Kids < 10 years"
          />
        </div>
        <div className="flex justify-center">
          <button 
            name="amountPeopleKids"
            className="focus:outline-none text-grey-dark hover:border-grey-darkest font-semibold p-3 w-10 h-10 text-sm hover:text-grey-darkest border border-grey rounded-full mr-2"
            style={{ touchAction: 'manipulation' }}
            onClick={(e) => handleAmountChange(e, false, false)}
            type="button"
          >
            -
          </button>
          <div className="py-2 px-8 border border-grey no-underline 
            rounded-full bg-transparent text-black font-sans font-semibold text-sm mr-2"
          >
            {amountPeopleKids}
          </div>
          <button
            name="amountPeopleKids"
            className="focus:outline-none text-grey-dark hover:border-grey-darkest font-semibold p-3 w-10 h-10 text-sm hover:text-grey-darkest border border-grey rounded-full"
            style={{ touchAction: 'manipulation' }}
            onClick={(e) => handleAmountChange(e, false, true)}
            type="button"
          >
          +
          </button>
        </div>

        <div className="flex mt-8 text-sm justify-center md:justify-end">
          <div>
            <div className="flex items-center text-sky font-bold">
              <FormattedMessage
                id="booking.amountForm.bookerAttending.label"
                defaultMessage="Are you attending yourself?"
              />
              {/* <HelpButton classNameAppend="ml-2" onClick={() => { console.log('hiii') }} /> */}
            </div>
            <div className="flex flex-col">
              <div>
                <button
                  onClick={() => onChange('bookerNotAttending', false)}
                  className={`flex items-center mt-2
                    ${!booking.bookerNotAttending ? 'font-bold' : ''}
                    ${amountPeople === 0 ? 'opacity-50 cursor-not-allowed' : ''}
                  `}
                  type="button"
                  disabled={amountPeople === 0}
                >
                  <FormattedRadioButton checked={!booking.bookerNotAttending} />
                  <FormattedMessage id="booking.amountForm.bookerAttending.yes" defaultMessage="Yes" />
                </button>
              </div>
              <div>
                <button
                  onClick={() => onChange('bookerNotAttending', true)}
                  className={`flex items-center mt-2 ${booking.bookerNotAttending ? 'font-bold' : ''}`}
                  type="button"
                >
                  <FormattedRadioButton checked={booking.bookerNotAttending} />
                  <FormattedMessage id="booking.amountForm.bookerAttending.no" defaultMessage="No, booking for others" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <Button
          onClick={updateBooking}
          className={`
            mt-8 whitespace-no-wrap self-end
            ${atUserBookingsCapacity && 
              'opacity-50 cursor-not-allowed'
            }
          `}
          disabled={(amountPeople + amountPeopleKids) < 1}
        >
          <FormattedMessage
            id="booking.amountForm.guest.button"
            defaultMessage="Continue"
          />
        </Button>
      </div>
      
    </div>
  ) 
}


PeopleAmountBlock.propTypes = {
  user: PropTypes.shape({
    user: PropTypes.object
  }),
  booking: PropTypes.shape({
    booking: PropTypes.object
  }),
  updateBooking: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  getKey: PropTypes.func.isRequired,
  atUserBookingsCapacity: PropTypes.bool
}

PeopleAmountBlock.defaultProps = {
  user: null,
  booking: null,
  atUserBookingsCapacity: false
}

export default injectIntl(PeopleAmountBlock)